import Form from 'react-bootstrap/Form';
import React, { useState, useEffect } from "react";
import {useNavigate} from 'react-router-dom';
import ImageTitle from '../components/shared/ImageTitle.js';
import LongButton from '../components/shared/LongButton.js';
import CollapsibleDiv from '../components/shared/CollapsibleDiv.js';
import '../css/Enroll.css';

function Enroll(props) {
    const navigate = useNavigate();
    const PUBLIC_URL = process.env.PUBLIC_URL;
    const imgPaymentMethod = process.env.REACT_APP_URL_IMAGE + "paymentmethod.jpg";
    const [content, setContent] = useState({
      event_Status: "",
      event_Picture: "",
      event_Button_Wording: "",
      event_PreOrder_Method: "",
      event_PreOrder_TnC: "",
      allButton_Color: "",
      allButton_FontColor: "",
      allTitle_Color: "",
      allTitle_FontColor: "",
      Event_Version: ""
    }); 

    const url = new URL(window.location.href);
    let baseUrl = `${url.protocol}//${url.host}/`;

    if (process.env.REACT_APP_API_URL != ""){
      baseUrl = process.env.REACT_APP_API_URL;
    }
    
    let eventUrl = baseUrl + "frontend/api/Enroll/GetEventStatus";
    let trackingUrl = baseUrl + "frontend/api/Enroll/InsertTrackingChannel";
    let eventName = window.name;
    if(window.name==='20260910_crab') navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-internal-event-20260910_crab');


console.log(process.env.REACT_APP_API_URL);
    if(props.isdebugmode) console.log(baseUrl);
    if(props.isdebugmode) console.log(eventUrl);
    if(props.isdebugmode) console.log(process.env.REACT_APP_ENV);
    const eventButtonOnClick = (e) => {

      if (content.Event_Version == 1)
      {
        navigate('../' + PUBLIC_URL + '/' + eventName + '/enrollM1?src=' + props.channel);
      }
      else if (content.Event_Version == 2)
      {
        navigate('../' + PUBLIC_URL + '/' + eventName + '/multi/enrollm1step1?src=' + props.channel);
      }
      else if (content.Event_Version == 3)
      {
        navigate('../' + PUBLIC_URL + '/' + eventName + '/npenrollM1?src=' + props.channel);
      }
      else
      {
        navigate('../' + PUBLIC_URL + '/fail-wrong-url');
      }
    };

    useEffect(() => {
      fetch(eventUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "event_Name": eventName
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result);
        if (result.IsSuccess == null){
          setContent(previousState => {
            return { 
              ...previousState,
              event_Status : result.Event_Status,
              event_Button_Wording : result.Event_Button_Wording,
              event_Picture : result.Event_Picture,
              event_PreOrder_Method : result.Event_PreOrder_Method,
              event_PreOrder_TnC : result.Event_PreOrder_TnC,
              allButton_Color : result.AllButton_Color,
              allButton_FontColor : result.AllButton_FontColor,
              allTitle_Color : result.AllTitle_Color,
              allTitle_FontColor : result.AllTitle_FontColor,
              Event_Version : result.Event_Version
            }
          });
        } else {
          navigate('../' + PUBLIC_URL + '/fail-wrong-url');
        }
      })
      .catch(err => { 
        navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-error');
       });

      fetch(trackingUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "event_Name": eventName,
          "source": props.channel
        })
      })
      .then(response => response.json())
      .then(response => { 
        //console.log("tracking success");
      })
      .catch(err => { if(props.isdebugmode) console.log(err); });

      window.QueueIt && window.QueueIt.validateUser();
    }, []);

    
  return (
    <>
      <Form>
          <ImageTitle src={content.event_Picture} alt="logo" />
          {
            content.event_Status === "Processing" && <LongButton class="enroll-button" text={content.event_Button_Wording} bgColor={content.allButton_Color} fontColor={content.allButton_FontColor} onClick={() => { eventButtonOnClick(); }}></LongButton>
          }
          {
            (content.Event_Version == 1 || content.Event_Version == 2) &&
            <>
              <ImageTitle src={imgPaymentMethod} alt="PaymentLogo" />
              <CollapsibleDiv title="預購方法" content={{__html: content.event_PreOrder_Method}}></CollapsibleDiv>
              <CollapsibleDiv title="預購條款及細則" content={{__html: content.event_PreOrder_TnC}}></CollapsibleDiv>
            </>
          }
          {
            content.Event_Version == 3 &&
            <>
              <CollapsibleDiv title="領取方法" content={{__html: content.event_PreOrder_Method}}></CollapsibleDiv>
              <CollapsibleDiv title="使用條款" content={{__html: content.event_PreOrder_TnC}}></CollapsibleDiv>
            </>
          }
      </Form>
    </>
  );
}

export default Enroll;
